module.exports = __webpack_public_path__ + "img/contenedor29.879e103b.png";